// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';

import Review from './Review';
import ReviewsList from './ReviewsList';
import Timelapse from './Timelapse';

export default class ReviewsSummary extends ApiObject {

  timelapse: Timelapse = new Timelapse();
  reviewsList: ReviewsList = new ReviewsList();

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize timelapse
    this.timelapse = new Timelapse();
    this.timelapse.setFromTime(data.fromTime / 1000);
    this.timelapse.setToTime(data.toTime / 1000);

    // -- deserialize reviews list
    this.reviewsList = new ReviewsList();
    this.reviewsList.fromJson(data); // TODO: change for data.reviews
  }

  getStarDistributionForGraph() {
    const starDistribution = this.getStarDistribution();
    const totalOfVotes = this.reviewsList.reviews.length;

    // empty array, there is max 5 stars
    const data = [
      { label: '1/5', value: 0 },
      { label: '2/5', value: 0 },
      { label: '3/5', value: 0 },
      { label: '4/5', value: 0 },
      { label: '5/5', value: 0 }
    ];

    _.each(this.reviewsList.reviews, (review: Review) => {
      const nbVotes = starDistribution[review.rate - 1];
      data[review.rate - 1].value = (nbVotes / totalOfVotes) * 100;
    });

    return data;
  }

  getStarDistribution() {
    // empty array, there is max 5 stars
    const data = [0, 0, 0, 0, 0];

    _.each(this.reviewsList.reviews, (review: Review) => {
      data[review.rate - 1] += 1;
    });

    return data;
  }

  getAverageRate() {
    let total = 0;
    _.each(this.reviewsList.reviews, (review: Review) => {
      total += review.rate;
    });

    return Math.floor(total / this.reviewsList.reviews.length);
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/ReviewsSummary.js